import _ from '@/underscore'
import $ from '@/jquery'
import Backbone from '@/backbone'
import upsell from '@/io.ox/core/upsell'
import { createIcon, createIllustration } from '@/io.ox/core/components'

export default Backbone.View.extend({

  tagName: 'div',

  events: {
    'click a': 'onClick'
  },

  onClick (e) {
    e.preventDefault()
    upsell.trigger({
      type: 'custom',
      id: this.options.id,
      missing: this.options.missing || upsell.missingInUpsellTrigger(this.condition).join(' ')
    })
  },

  initialize (options = {}) {
    this.options = {
      color: 'var(--upsell)',
      condition: '',
      description: '',
      enabled: true,
      icon: upsell.getDefaultIcon(),
      linkClass: '',
      // quota widget might set a pre-defined missing value ("storage")
      missing: '',
      requires: '',
      title: '',
      ...options,
      ...upsell.getTriggerConfig(options.id)
    }

    // condition is either requires or condition
    // requires will be deprecated but still it stays supported for backward compatibility for now
    this.condition = this.options.requires || this.options.condition || ''

    // A11y: Links in folder tree need to be nested in li with role presentation
    if (/^folderview\//.test(this.options.id)) {
      // this.setElement('<li role="presentation">')
      this.$el.addClass(this.className)
    }

    // ensure io-ox-upsell-link class
    this.$el.addClass('io-ox-upsell-link')

    this.customize = this.options.customize
    this.icon = this.options.icon
    this.visible = this.options.enabled && upsell.shouldShowUpsellTrigger(this.condition)
  },

  render () {
    if (this.visible) {
      const { color, illustration, linkClass, title, description } = this.options
      const node = $('<a href="#">').addClass(linkClass)
      if (illustration) {
        node.addClass('flex-row flex-center').append(
          createIllustration('illustrations/rocket.svg', { width: 40 }).addClass('me-16 shrink-0 opacity-100')
        )
      } else if (this.icon) {
        node.addClass('flex-row flex-center').append(
          createIcon(this.icon).addClass('me-8').css('color', color)
        )
      }
      if (title && description) {
        node.append(
          $('<div class="flex flex-col">').append(
            title ? $('<h3 class="m-0 font-bold text-sm">').text(title) : $(),
            description ? $('<div class="text-pretty">').text(description) : $()
          )
        )
      } else {
        node.append($('<div class="grow">').text(title || description || ''))
      }
      // A11y: Links in foldertree need to be role treeitem
      // if (/^folderview\//.test(this.options.id)) node.attr('role', 'treeitem')
      this.$el.append(node)
      if (_.isFunction(this.customize)) this.customize()
    } else {
      this.$el.hide()
    }
    return this
  }
})
